$(window).on('scroll', function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 3) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
});

$('.navigation__responsive-menu').on('click', function() {
    $(this).toggleClass('navigation__responsive-menu--active');
    $('.navigation__items').toggleClass('navigation__items-active');
});

$(window).on('resize', function() {
    if ($(window).width() >= 960) {
        if ($('.navigation__items-active')[0]) {
            $('.navigation__items').removeClass('navigation__items-active');
        }
        if ($('.navigation__responsive-menu--active')[0]) {
            $('.navigation__responsive-menu').removeClass('navigation__responsive-menu--active');
        }
    }
});
